export const FILTERS = [
  'action',
  'outcome',
  'from',
  'to',
  'actorUserId',
  'organizationId',
  'resourceType',
  'resourceId',
];

// GET /api/internal/audit-logs/resources/:type/:id takes only these.
export const RESOURCE_FILTERS = ['action', 'outcome', 'from', 'to'];

/**
 * Query string of the audit log endpoints from the page's params.
 * Built by hand: the apps' API clients drop (DMC) or snake_case (TO) params.
 */
export function auditLogQuery(params, perPage, filters = FILTERS) {
  const page = Math.max(1, parseInt(params.get('page') ?? '1', 10) || 1);
  const query = new URLSearchParams({
    limit: String(perPage),
    offset: String((page - 1) * perPage),
  });
  filters.forEach((key) => {
    const value = params.get(key);
    if (value) query.set(key, value);
  });
  return query.toString();
}
